import { Socket } from "socket.io-client";
import ClientChatPacket from "../ClientChatPacket";

export default class LoginClientChatPacket extends ClientChatPacket {
    private username: string;

    public constructor(username: string) {
        super();

        this.username = username;
    }

    public send(socket: Socket) {
        socket.emit('login', {
            username: this.username,
        });
    }
}
